import NavBar from "./NavBar";
import Footer from "./Footer";
import { Radio, Users, Globe, Award } from "lucide-react";

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-black text-white flex flex-col">
      <NavBar />

      <main className="flex-1 pt-30 pb-20 px-4 bg-gradient-to-b from-[#042033] to-black">
        <div className="max-w-6xl mx-auto">
          {/* Hero Section */}
          <div className="text-center mb-20">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 tracking-tight">
              The Voice of the <span className="text-cyan-400">Community</span>
            </h1>
            <p className="text-white/60 text-lg max-w-3xl mx-auto leading-relaxed">
              Since 2010, Akaram Radio has been more than just a station. We are
              a cultural hub, connecting people through music, dialogue, and
              shared experiences.
            </p>
          </div>

          {/* Mission Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-24">
            {[
              {
                icon: Radio,
                title: "24/7 Broadcast",
                desc: "Non-stop music and entertainment streaming worldwide.",
              },
              {
                icon: Users,
                title: "Community First",
                desc: "Dedicated to serving and uplifting our local listeners.",
              },
              {
                icon: Globe,
                title: "Global Reach",
                desc: "Connecting the diaspora through digital waves.",
              },
              {
                icon: Award,
                title: "Award Winning",
                desc: "Recognized for excellence in independent broadcasting.",
              },
            ].map((item, i) => (
              <div
                key={i}
                className="bg-white/5 border border-white/10 p-8 rounded-2xl hover:bg-white/10 transition-colors text-center group"
              >
                <div className="w-14 h-14 bg-cyan-500/20 rounded-xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                  <item.icon className="w-7 h-7 text-cyan-400" />
                </div>
                <h3 className="text-xl font-bold mb-3">{item.title}</h3>
                <p className="text-white/50 text-sm">{item.desc}</p>
              </div>
            ))}
          </div>

          {/* Story Section */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24">
            <div className="space-y-6">
              <h2 className="text-3xl md:text-4xl font-bold">Our Story</h2>
              <div className="space-y-4 text-white/70 leading-relaxed">
                <p>
                  It started in a small basement studio with a simple microphone
                  and a big dream: to create a platform where every voice could
                  be heard. What began as a weekly hour-long show has grown into
                  a full-fledged media organization.
                </p>
                <p>
                  Today, we host over 20 unique programs ranging from jazz and
                  classical music to political talk shows and youth culture
                  segments. Our team of dedicated volunteers and professionals
                  work around the clock to keep our signal strong and our
                  content fresh.
                </p>
              </div>
            </div>
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/20 to-purple-500/20 rounded-3xl blur-2xl transform rotate-3" />
              <img
                src="https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?q=80&w=2000&auto=format&fit=crop"
                alt="Radio Studio"
                className="relative rounded-3xl border border-white/10 shadow-2xl"
              />
            </div>
          </div>

          {/* Team Stats */}
          <div className="bg-[#0B1623] rounded-3xl p-12 border border-white/10 text-center">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
              {[
                { label: "Daily Listeners", value: "45k+" },
                { label: "Countries", value: "12" },
                { label: "Team Members", value: "28" },
                { label: "Years On Air", value: "15" },
              ].map((stat, i) => (
                <div key={i}>
                  <div className="text-4xl md:text-5xl font-bold text-white mb-2">
                    {stat.value}
                  </div>
                  <div className="text-cyan-400 text-sm font-medium uppercase tracking-wider">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
